<!-- HEADER ROW GOES HERE -->
<div class="task-list flex-vertical">
  <div class="task-block-row header full-width" sytle="margin-bottom: 10px;">
    <div class="task-cell flex-2">
      &nbsp;
    </div>

    <div class="task-cell flex-2 employee-margin">
      Controle
    </div>

    <div class="task-cell flex-2">
      T-datum
    </div>

    <div class="task-cell flex-2">
      Filiaal
    </div>

    <div class="task-cell flex-3">
      Installateurs
    </div>

    <div class="task-cell flex-2">
      Aantallen
    </div>

    <div class="task-cell flex-3 status-cell">
      Status
    </div>
  </div>
  <ng-template #loading>
    <div style="align-self: center;">
      <mat-spinner
        style="margin: auto;"
        color="primary"
        diameter="24"
      ></mat-spinner>
    </div>
  </ng-template>
  <ng-container *ngIf="!loadingAssignments; else loading">
    <ng-template #noItems>
      <div
        *ngIf="tourAssignments == null || tourAssignments.length === 0"
        class="center-text"
      >
        Geen uit te voeren projecten op deze dag
      </div>
    </ng-template>
    <ng-container
      *ngIf="
        tourAssignments != null && tourAssignments.length > 0;
        else noItems
      "
    >
      <div *ngFor="let tour of tourAssignments" class="task-block">
        <div
          class="task-block-row clickable full-width"
          [ngClass]="tour.executedClass"
          (click)="openTask(tour)"
        >
          <div class="task-cell flex-2">
            <employee-circle-display
              *ngIf="tour.atelierEmployee"
              [firstName]="tour.atelierEmployee.firstName"
              [lastName]="tour.atelierEmployee.lastName"
              [profilePicture]="tour.atelierEmployee.profilePicture"
            >
            </employee-circle-display>
          </div>

          <div class="task-cell flex-2 employee-margin">
            <employee-circle-display
              *ngIf="tour.reviewEmployee"
              [firstName]="tour.reviewEmployee.firstName"
              [lastName]="tour.reviewEmployee.lastName"
              [profilePicture]="tour.reviewEmployee.profilePicture"
            >
            </employee-circle-display>
          </div>

          <div class="task-cell flex-2">
            {{ tour.date | formatDate }}
          </div>

          <div class="task-cell flex-2">
            {{ tour.branch }}
          </div>

          <div class="task-cell flex-3">
            &nbsp;
            <b>{{ tour.placer?.firstName }} {{ tour.placer?.lastName }}</b>
          </div>

          <div class="task-cell flex-2">
            &nbsp;
            {{ tour.nbToPlace }} / {{ tour.nbSold }} / {{ tour.nbAdjustment }}
          </div>

          <div class="task-cell flex-3 status-cell">
            <div class="status-display" [ngClass]="tour.executedClass">
              {{ tour.statusText }}
            </div>
          </div>
        </div>
        <atelier-assignment-detail
          *ngIf="tour.id === selectedTourId"
          class="full-width"
          [tourId]="tour.id"
          [reviewingUserId]="tour.reviewEmployee?.userId"
          [atelierUserId]="tour.atelierEmployee?.userId"
          (checkUpdate)="onCheckUpdate($event)"
        ></atelier-assignment-detail>
      </div>
    </ng-container>
  </ng-container>
</div>
